var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTheBranding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_2",
    "data-name": "Grupo 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 406.329,
    height: 246.361,
    viewBox: "0 0 406.329 246.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1",
    "data-name": "Rect\\xE1ngulo 1",
    width: 406.329,
    height: 246.361,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M14.364,59.783c3.937.01,10.278-1.77,10.186-1.77v-8.09a29.093,29.093,0,0,1-7.14-.494c-2.751-.741-4.6-2.461-4.59-6.73l.042-18.469,12.31.029L25.2,15.3l-12.31-.03L12.918,0H.106L0,44.841C-.026,54.474,6.072,59.76,14.364,59.783",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M63.7,34.834l-.062,24.26h12.9l.072-28c.026-10.552-6.405-17.269-16.539-17.3-7.035.069-11.235.913-15.6,4.5L44.533,0h-12.9l-.158,59.092h12.9l.055-21.963C44.448,30.512,48.4,25.665,54.845,25.6c5.527.016,8.865,3.54,8.853,9.234",
    transform: "translate(4.661 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M102.752,57.984a25.521,25.521,0,0,0,20.292-9.158l-7.351-6.716c-3.444,3.841-7.637,5.843-12,5.829A11.269,11.269,0,0,1,93,40.962l31.175-8.131c-.47-12.894-9.076-20.877-22.142-20.824-14.153.046-23.134,9.405-23.17,22.969-.033,13.737,9.569,22.971,23.89,23.006m-.072-36.429c4.355.013,7.446,2.031,8.86,6.388L91.763,33.253c.441-7.621,4.552-11.715,10.917-11.7",
    transform: "translate(11.677 1.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M38.072,101.137C44.394,99.47,48.281,94.508,48.3,88.191c.023-9.1-8.046-14.764-21.021-14.8L.152,73.325,0,132.366H28.053c13.646.037,22.254-6.174,22.277-16.284.023-7.752-4.595-13.49-12.258-14.944M13.435,84.224l13.141.033c5.05-.069,8.079,2.3,8.069,6.344-.009,4.125-3.052,6.562-8.1,6.549L13.4,97.117ZM26.479,121.5l-13.141-.033.037-13.987,13.141.033c6.231-.065,10.1,2.556,10.093,6.849-.014,4.549-3.9,7.154-10.129,7.138",
    transform: "translate(0 10.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M53.652,85.334l-.116,45.339H66.43l.056-21.939c.02-7.623,5.728-12.55,14.939-11.685l.03-12.145c-6.7.065-11.217.909-14.93,4.892l.021-4.428Z",
    transform: "translate(7.927 12.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M117.775,125.513l-.017,5.105h12.816L130.69,85.3l-12.816-.033-.017,4.562c-4.235-3.568-8.252-4.522-14.617-4.538-12.56.053-20.81,8.788-20.843,22.439-.036,13.9,8.394,23.537,21.209,23.57,6.111.016,10.976-1.357,14.17-5.784M94.345,108.1c.11-7.286,4.937-12.451,11.942-12.451a10.906,10.906,0,0,1,10.084,6.225,13.811,13.811,0,0,1-1,13.376,10.944,10.944,0,0,1-9.148,5.357c-7.092-.02-11.8-5.14-11.875-12.507",
    transform: "translate(12.201 12.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M150,108.449c.016-6.619,3.884-11.466,10.332-11.531,5.527.017,8.867,3.54,8.853,9.234l-.062,24.492h12.9l.072-28.228c.026-10.552-6.415-16.823-16.453-17.295a24.272,24.272,0,0,0-15.6,4.672l.021-4.448-12.9-.032-.115,45.33h12.894Z",
    transform: "translate(20.293 12.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M308.382,130.644l.072-28.228c.026-10.552-6.415-16.823-16.454-17.295a24.278,24.278,0,0,0-15.6,4.672l.02-4.446-12.894-.033-.116,45.33h12.9l.056-22.195c.016-6.617,3.884-11.465,10.332-11.531,5.527.017,8.865,3.54,8.853,9.235l-.062,24.491Z",
    transform: "translate(39.004 12.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M219.9,127.313l-.016,5.076h12.813l.157-59.042-12.812-.036-.059,18.162c-4.56-3.429-8.193-4.469-14.554-4.486-12.563-.033-20.959,9.077-20.992,22.812-.036,13.9,8.394,23.216,21.208,23.25,6.195.016,10.776-1.647,14.256-5.737m-22.572-17.374c.106-7.286,4.722-12.47,11.422-12.451,6.615.016,11.21,5.136,11.189,12.507s-4.639,12.467-11.255,12.451c-6.783-.02-11.288-5.14-11.357-12.507",
    transform: "translate(27.31 10.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M246.052,82.856a6.444,6.444,0,1,0-6.444-6.443,6.443,6.443,0,0,0,6.444,6.443",
    transform: "translate(35.479 10.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M252.532,85.29l-12.9-.033-.115,45.363h12.9Z",
    transform: "translate(35.467 12.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M346.62,85.273l-.017,4.489c-4.585-3.84-8.266-4.422-14.771-4.347-12.2-.031-20.6,9.12-20.63,22.658-.039,13.9,8.49,23.184,20.871,23.216,6.326.014,10.606-1.481,14.45-5.692l-.014,4.213c-.017,6.5-5.016,10.678-12.856,10.658a25.363,25.363,0,0,1-14.866-4.848l-5.1,9.606a37.257,37.257,0,0,0,20.829,6.382c15.32.038,25.586-8.574,25.621-22.2l.111-44.094Zm-11.314,35.6c-6.77-.017-11.21-5.107-11.283-12.412.111-7.3,4.67-12.458,11.35-12.441s11.21,5.1,11.189,12.5c-.017,7.305-4.576,12.374-11.256,12.357",
    transform: "translate(46.08 12.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M235.946,145.673H223.134l-.106,44.84c-.026,9.632,6.073,14.919,14.364,14.942,3.937.01,10.278-1.769,10.186-1.769v-8.092s-5.413-.367-7.139-.494c-2.841-.208-4.6-2.461-4.591-6.73l.042-18.469,12.31.03.026-8.962-12.31-.03Z",
    transform: "translate(33.024 21.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M204.864,157.749l-12.9-.033-.115,45.339h12.9l.055-21.937c.021-7.624,5.728-12.55,14.939-11.686l.03-12.145c-6.7.067-11.217.91-14.928,4.893Z",
    transform: "translate(28.408 23.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M13.363,180.588l28.363.072.026-11.024-28.363-.073.033-12.794,31.561.083.03-11.14H0v59.052H45.789l.026-11.044-32.489-.083Z",
    transform: "translate(0 21.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M92.667,157.681H78.561l-8.875,13.747-8.257-13.747H46.651l14.468,22.1-15.678,23.2H59.72l9.966-14.841,9.01,14.841H93.56l-15.31-23.2Z",
    transform: "translate(6.729 23.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M122.729,157.71c-6.112-.016-9.33,1.177-14.252,4.457l.017-4.476-12.9-.033-.157,65.326,12.9.033.06-24.989c3.3,3.59,8.186,5.642,14.468,5.658,12.645.033,20.963-9.076,21-22.726.036-13.9-8.485-23.216-21.13-23.25m-3.1,35.25c-6.615-.02-11.209-5.054-11.189-12.507.016-7.286,4.637-12.385,11.251-12.366s11.124,5.219,11.108,12.422c-.02,7.367-4.554,12.467-11.17,12.451",
    transform: "translate(14.132 23.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M166.688,157.718c-14.153.046-23.135,9.405-23.17,22.971-.033,13.736,9.569,22.969,23.89,23.009a25.539,25.539,0,0,0,20.291-9.158l-7.351-6.72c-3.443,3.841-7.637,5.843-11.994,5.83a11.274,11.274,0,0,1-10.7-6.977l31.176-8.13c-.471-12.9-9.077-20.878-22.142-20.825m-10.27,21.245c.441-7.621,4.551-11.715,10.917-11.7,4.353.014,7.445,2.031,8.859,6.389Z",
    transform: "translate(21.251 23.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M264.263,170.366c.007-2.343,2.185-3.342,5.2-3.335,3.766.009,8.787,1.613,13.723,4.39l4.463-8.784a33.633,33.633,0,0,0-17.575-5.071c-9.8-.023-17.768,4.729-17.791,14.023-.042,15.828,23.331,12.04,23.312,19.241,0,2.428-2.435,3.512-5.7,3.5a27.148,27.148,0,0,1-15.648-5.652l-4.21,8.7c5.1,4.114,12.207,6.309,19.5,6.329,10.217.025,18.353-4.812,18.376-14.023.125-15.908-23.666-12.539-23.65-19.322",
    transform: "translate(37.024 23.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M308.677,176.489a12.209,12.209,0,1,0,12.18,12.272,12.01,12.01,0,0,0-12.18-12.272m-.054,22.049a9.866,9.866,0,1,1,9.794-9.783,9.678,9.678,0,0,1-9.794,9.783",
    transform: "translate(43.893 26.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M312.976,185.682c.006-2.254-1.83-3.719-4.572-3.725l-5.192-.014-.029,11.21,2.443.006.009-3.595,1.829,0,3.157,3.6,2.931.008-3.468-3.849a3.774,3.774,0,0,0,2.891-3.647m-4.6,1.691-2.742-.007.008-3.223,2.742.007c1.271,0,2.123.617,2.12,1.585s-.858,1.641-2.129,1.637",
    transform: "translate(44.893 26.941)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheBranding);
export default __webpack_public_path__ + "static/media/TheBranding.9a256888a8ca63435bc3a9e339e22186.svg";
export { ForwardRef as ReactComponent };